import { render } from "./user-selector.vue?vue&type=template&id=412eba5b&ts=true"
import script from "./user-selector.vue?vue&type=script&lang=ts"
export * from "./user-selector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__